import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';

export class AirlineListView extends React.Component<AirlineListViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const columns: Column[] = [
			{
				key: 'title',
				title: 'Title',
				dataIndex: 'title',
				render: (text, record: AirlineSummary) => <Link to={`/general/airlines/${record.id}`}>{text}</Link>,
			},
			{
				key: 'regionName',
				title: 'Region',
				dataIndex: 'regionName',
				filter: {
					field: 'regionId',
					type: 'foreignKey',
					render: (value, onChange) => (
						<RegionEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={(newValue) => { onChange(newValue != null ? newValue.id : null); }}
							setBusy={this.props.setBusy}
						/>
					)
				}
			},
			{
				key: 'iataCode',
				title: 'IataCode',
				dataIndex: 'iataCode'
			},
			{
				key: 'icaoCode',
				title: 'IcaoCode',
				dataIndex: 'icaoCode'
			},
			{
				key: 'iso3Code',
				title: 'Iso3Code',
				dataIndex: 'iso3Code'
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/airlines/list/airline-list.view.tsx